import { AlertCircle } from "lucide-react";

interface AuthErrorProps {
  message: string;
  className?: string;
}

export function AuthError({ message, className = "" }: AuthErrorProps) {
  return (
    <div className={`bg-red-50 border-l-4 border-red-400 p-4 ${className}`}>
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <AlertCircle className="h-5 w-5 text-red-400" />
        </div>
        <div className="ml-3">
          <p className="text-sm text-red-700">
            {message}
          </p>
        </div>
      </div>
    </div>
  );
}
